module.exports = __webpack_public_path__ + "static/PM-afec8b9729a090089cfc6b9b23360dd2.png";